import type { InjectionKey } from 'vue'
import type { IDescriptionsInject } from './descriptions.type'

export const elDescriptionsKey =
  'elDescriptions' as any as InjectionKey<IDescriptionsInject>
